import styles from "./UiFlash.module.scss";
import { useEffect } from "react";

type UiFlashProps = {
  message: string | null;
  onDismiss: () => void;
  durationMs?: number;
};

export const UiFlash = ({ message, onDismiss, durationMs = 4200 }: UiFlashProps) => {
  useEffect(() => {
    if (!message) return;
    const id = window.setTimeout(() => onDismiss(), durationMs);
    return () => window.clearTimeout(id);
  }, [message, durationMs, onDismiss]);

  if (!message) return null;

  return (
    <div className={styles["comp"]} role="status">
      <p className={styles["comp__message"]}>{message}</p>
    </div>
  );
};
